import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Home, Compass, Film, Tv, GraduationCap, Music, Cpu, Gamepad2, Dumbbell, Newspaper, Radio as RadioIcon, History, ThumbsUp, Clock, ListVideo, Upload as UploadIcon, LayoutDashboard, ShieldCheck, Sparkles, Zap, Crown, Tag, Megaphone, DollarSign, Link2 as LinkIcon, QrCode, CreditCard, Image as ImageIcon, Flame, FlaskConical, Bookmark, Library, Headphones, User as UserIcon, Heart } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { mySubscriptions, resolveFileUrl } from '../lib/api';

const catIcons = {
  movies: Film, series: Tv, courses: GraduationCap, music: Music, tech: Cpu,
  gaming: Gamepad2, fitness: Dumbbell, news: Newspaper, live: RadioIcon,
  trending: Sparkles, shorts: Zap,
};

export default function Sidebar({ mobile, onNavigate }) {
  const { user, categories } = useApp();
  const [subs, setSubs] = useState([]);
  const isListener = user?.profile_type === 'listener';

  useEffect(() => {
    if (!user) return;
    (async () => { try { setSubs(await mySubscriptions()); } catch {} })();
  }, [user]);

  const Link1 = ({ to, icon: Ic, label, end, pillColor, testid }) => (
    <NavLink to={to} end={end} data-testid={testid} onClick={onNavigate}
             className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
      <Ic className="w-5 h-5" style={pillColor ? { color: pillColor } : undefined} />
      <span>{label}</span>
    </NavLink>
  );

  return (
    <aside className={`${mobile ? 'w-full' : 'hidden lg:flex fixed top-14 bottom-0 left-0 w-60 border-r border-white/5'} flex-col bg-[var(--theme-bg)] overflow-y-auto scroll-x`}>
      {isListener ? (
        <>
          <nav className="px-3 py-4 space-y-1">
            <Link1 to="/feed" icon={Headphones} label="Music Reel" pillColor="#22d3ee" testid="sidebar-feed" />
            <Link1 to="/artists" icon={Music} label="Artists" pillColor="#a78bfa" testid="sidebar-artists" />
            <Link1 to="/listener" icon={UserIcon} label="My profile" testid="sidebar-listener" />
            <Link1 to="/hub" icon={Library} label="Knowledge Hub" pillColor="#22d3ee" testid="sidebar-hub" />
            <Link1 to="/academy" icon={GraduationCap} label="Music Biz Academy" pillColor="#ffcf52" testid="sidebar-academy-listener" />
            <Link1 to="/reapercast" icon={RadioIcon} label="Radio" pillColor="#a78bfa" />
            <Link1 to="/home" icon={Compass} label="Explore videos" />
            <Link1 to="/changelog" icon={Sparkles} label="What's new" pillColor="#ffcf52" testid="sidebar-changelog" />
          </nav>
          <div className="hair-line mx-4" />
          <nav className="px-3 py-4 space-y-1">
            <div className="px-3 text-[11px] uppercase tracking-wider text-white/40 font-bold mb-1">You</div>
            <Link1 to="/listener" icon={Heart} label="Liked tracks" />
            <Link1 to="/library?tab=liked" icon={ThumbsUp} label="Liked videos" />
            <Link1 to="/library?tab=watchlater" icon={Clock} label="Watch later" />
          </nav>
        </>
      ) : (
        <nav className="px-3 py-4 space-y-1">
          <Link1 to="/home" icon={Home} label="Home" end />
          <Link1 to="/feed" icon={Headphones} label="Music Reel" pillColor="#22d3ee" testid="sidebar-feed" />
          <Link1 to="/artists" icon={Music} label="Artists" pillColor="#a78bfa" testid="sidebar-artists" />
          <Link1 to="/shorts" icon={Zap} label="Shorts" pillColor="#ff6b8a" />
          <Link1 to="/category/trending" icon={Compass} label="Explore" />
          <Link1 to="/category/live" icon={RadioIcon} label="Live" />
          <Link1 to="/reapercast" icon={RadioIcon} label="ReaperCast Radio" pillColor="#a78bfa" testid="sidebar-reapercast" />
          <Link1 to="/academy" icon={GraduationCap} label="Music Biz Academy" pillColor="#ffcf52" testid="sidebar-academy" />
          <Link1 to="/income" icon={DollarSign} label="Income Tool" pillColor="#34d399" testid="sidebar-income" />
          <Link1 to="/royalty" icon={DollarSign} label="Royalty Dashboard" pillColor="#ffcf52" testid="sidebar-royalty" />
          <Link1 to="/hub" icon={Library} label="Knowledge Hub" pillColor="#22d3ee" testid="sidebar-hub" />
          <Link1 to="/research" icon={Bookmark} label="Research" pillColor="#22d3ee" testid="sidebar-research" />
          <Link1 to="/changelog" icon={Sparkles} label="What's new" pillColor="#ffcf52" testid="sidebar-changelog" />
          <Link1 to="/beta" icon={FlaskConical} label="Beta Program" pillColor="#22d3ee" testid="sidebar-beta" />
          <Link1 to="/library" icon={ListVideo} label="Library" />
        </nav>
      )}
      {!isListener && (<>
      <div className="hair-line mx-4" />
      <nav className="px-3 py-4 space-y-1">
        <div className="px-3 text-[11px] uppercase tracking-wider text-white/40 font-bold mb-1">You</div>
        <Link1 to="/library?tab=history" icon={History} label="History" />
        <Link1 to="/library?tab=liked" icon={ThumbsUp} label="Liked" />
        <Link1 to="/library?tab=watchlater" icon={Clock} label="Watch later" />
        <Link1 to="/upload" icon={UploadIcon} label="Upload" />
        <Link1 to="/migrate" icon={Flame} label="Migration Center" pillColor="#ff7a00" testid="sidebar-migrate" />
        <Link1 to="/studio" icon={LayoutDashboard} label="Creator Studio" />
        <Link1 to="/media" icon={ImageIcon} label="Media Library" pillColor="#a78bfa" />
        <Link1 to="/earnings" icon={DollarSign} label="Earnings" pillColor="#22d3ee" />
        <Link1 to="/marketing" icon={LinkIcon} label="Marketing" pillColor="#a78bfa" />
        <Link1 to="/ads" icon={Megaphone} label="Ads & Sponsors" />
        <Link1 to="/ads/marketplace" icon={CreditCard} label="Ad Marketplace" pillColor="#ffcf52" />
        <Link1 to="/tools/qr" icon={QrCode} label="QR Code Tool" pillColor="#a78bfa" />
        {(user?.role === 'admin' || user?.role === 'owner') && <Link1 to="/admin" icon={ShieldCheck} label="Admin" />}
        {user?.role === 'owner' && <Link1 to="/owner" icon={Crown} label="Owner" pillColor="#ffcf52" />}
        {user?.role === 'owner' && <Link1 to="/owner/ads" icon={Megaphone} label="Owner Ads" pillColor="#ffcf52" />}
      </nav>
      <div className="hair-line mx-4" />
      <nav className="px-3 py-4 space-y-1">
        <div className="px-3 text-[11px] uppercase tracking-wider text-white/40 font-bold mb-1">Categories</div>
        {(categories || []).map(c => {
          const Ic = catIcons[c.slug] || (c.type === 'custom' ? Tag : Compass);
          return <Link1 key={c.slug} to={`/category/${c.slug}`} icon={Ic} label={c.name} />;
        })}
      </nav>
      </>)}
      {subs.length > 0 && (<>
        <div className="hair-line mx-4" />
        <nav className="px-3 py-4 space-y-1">
          <div className="px-3 text-[11px] uppercase tracking-wider text-white/40 font-bold mb-1">{isListener ? 'Following' : 'Subscriptions'}</div>
          {subs.map(c => (
            <Link key={c.id} to={`/channel/${c.id}`} onClick={onNavigate} className="sidebar-link">
              <img src={resolveFileUrl(c.avatar)} alt={c.name} className="w-6 h-6 rounded-full object-cover" />
              <span className="truncate">{c.name}</span>
            </Link>
          ))}
        </nav>
      </>)}
      <div className="px-5 py-6 text-[11px] text-white/35">© {new Date().getFullYear()} ReaperCast</div>
    </aside>
  );
}
